<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="870" persistent>
      <v-card>
        <v-card-title class="text-h5 blue darken-4 white--text">
          {{ xprograma.id ? 'Editar Proyecto' : 'Crear Nuevo Proyecto' }}
          <v-spacer></v-spacer>
          <v-icon dark right @click="dialog = !dialog" :disabled="loading">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text>
          <v-form v-model="valid">
            <v-container>
              <v-row>
                <v-col cols="12" md="12">
                  <v-text-field
                    :counter="250"
                    v-model.trim="xprograma.programa"
                    @input="upper('programa', $event)"
                    label="* proyecto"
                    placeholder="nombre del proyecto"
                    prepend-inner-icon="mdi-bookmark"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    :counter="25"
                    v-model.trim="xprograma.codigo"
                    @input="upper('codigo', $event)"
                    label="* codigo"
                    placeholder="codigo del programa"
                    prepend-inner-icon="mdi-code-not-equal-variant"
                    color="green"
                    success
                    outlined
                    readonly
                    dense
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    :counter="4"
                    v-model.number="xprograma.gestion"
                    type="number"
                    label="* gestion"
                    placeholder="gestion"
                    prepend-inner-icon="mdi-calendar-today"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    :counter="3"
                    v-model="xprograma.version"
                    label="* version"
                    placeholder="version"
                    prepend-inner-icon="mdi-stairs-box"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-select v-model="xprograma.area" label="* Area" dense outlined :items="areas"></v-select>
                </v-col>
                <v-col cols="12" md="5">
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dateFormatted2"
                        label="* fecha inicio"
                        persistent-hint
                        prepend-inner-icon="mdi-calendar"
                        outlined
                        dense
                        required
                        v-bind="attrs"
                        @blur="date2 = parseDate(dateFormatted2)"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date2" no-title @input="menu2 = false"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="4">
                  <v-menu
                    ref="menu3"
                    v-model="menu3"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dateFormatted3"
                        label="* fecha culminacion"
                        persistent-hint
                        prepend-inner-icon="mdi-calendar"
                        outlined
                        dense
                        required
                        v-bind="attrs"
                        @blur="date3 = parseDate(dateFormatted3)"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date3" no-title @input="menu3 = false"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="3">
                  <v-select
                    v-model="xprograma.mes"
                    label="* Mes"
                    item-value="id"
                    dense
                    outlined
                    :items="meses"
                  ></v-select>
                </v-col>

                <v-col cols="12" md="4">
                  <v-select
                    :items="categorias"
                    item-value="id"
                    v-model="xprograma.categoria_id"
                    label="* Categoria"
                    solo
                  ></v-select>
                </v-col>

                <v-col cols="12" md="4">
                  <v-select
                    :items="departamentos"
                    item-value="id"
                    v-model="xprograma.departamento_id"
                    label="* Departamento"
                    solo
                  ></v-select>
                </v-col>

                <v-col cols="12" md="4">
                  <v-select :items="sedes" item-value="id" v-model="xprograma.sede_id" label="* Sede" solo></v-select>
                </v-col>

                <v-col cols="12" md="12" vv-if="!xprograma.id">
                  <v-file-input
                    v-model="xdocumento"
                    dense
                    outlined
                    label="* Adjuntar el proyecto (formato word)"
                    placeholder="Seleccionar documento..."
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <p class="text-center red--text">{{ msg }}</p>
          <v-progress-linear v-if="loading" indeterminate color="indigo"></v-progress-linear>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" class="darken-2 white--text" tile @click="dialog = !dialog" :disabled="loading">
            <v-icon small lef>
              mdi-close
            </v-icon>
            Cancelar
          </v-btn>
          <v-btn color="green" class="darken-2 white--text" tile @click="enviar()" :disabled="loading">
            <v-icon small left>
              mdi-check
            </v-icon>
            {{ xprograma.id ? 'Guardar Modificaciones' : 'Registrar proyecto' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div><programautils ref="programautils" /></div>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  import programautils from '@/components/AXprogramautils';
  export default {
    data: (vm) => ({
      dialog: false,
      loading: false,
      valid: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      date2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      date3: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      dateFormatted: vm.formatDate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      ),
      dateFormatted2: vm.formatDate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      ),
      dateFormatted3: vm.formatDate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      ),
      menu1: false,
      menu2: false,
      menu3: false,
      msg: '',
      categorias: [],
      departamentos: [],
      sedes: [],
      edit: null,
      xdocumento: null,
      xprograma: {
        id: null,
        codigo: null,
        programa: null,
        gestion: null,
        version: null,
        area: null,
        fecha_inicio: null,
        fecha_culminacion: null,
        categoria_id: null,
        departamento_id: null,
        sede_id: null,
        mes: null,
        version_padre: 0, // por defecto
      },
      xarchivo: {
        Idprograma: null,
        Tipo_documento: null,
        Documento: null,
      },
      meses: [
        { id: 0, text: 'Enero' },
        { id: 1, text: 'Febrero' },
        { id: 2, text: 'Marzo' },
        { id: 3, text: 'Abril' },
        { id: 4, text: 'Mayo' },
        { id: 5, text: 'Junio' },
        { id: 6, text: 'Julio' },
        { id: 7, text: 'Agosto' },
        { id: 8, text: 'Septiembre' },
        { id: 9, text: 'Octubre' },
        { id: 10, text: 'Noviembre' },
        { id: 11, text: 'Diciembre' },
      ],
      areas: ['SALUD', 'EMPRESARIAL', 'LEGAL', 'INGENIERIA', 'SOCIAL'],
    }),
    components: { programautils },
    computed: {
      computedDateFormatted() {
        return this.formatDate(this.date);
      },
    },
    watch: {
      date() {
        this.dateFormatted = this.formatDate(this.date);
      },
      date2() {
        this.dateFormatted2 = this.formatDate(this.date2);
      },
      date3() {
        this.dateFormatted3 = this.formatDate(this.date3);
      },
      xdocumento: function() {
        if (!this.xdocumento) {
          this.xarchivo.Tipo_documento = null;
          this.xarchivo.Documento = null;
          return;
        }
        //window.console.log(this.xdocumento);
        const vue = this;
        let reader = new FileReader();
        reader.readAsDataURL(this.xdocumento);
        reader.onload = function() {
          vue.xarchivo.Tipo_documento = vue.xdocumento.type;
          vue.xarchivo.Documento = reader.result;
          //window.console.log(reader.result);
        };
        reader.onerror = function(err) {
          window.console.log('Error:', err);
        };
      },
      'xprograma.programa': function() {
        this.generatecode();
      },
      'xprograma.version': function() {
        this.generatecode();
      },
      'xprograma.area': function() {
        this.generatecode();
      },
    },
    methods: {
      formatDate(date) {
        if (!date) return null;

        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
        //return `${day}-${month}-${year}`;
      },
      parseDate(date) {
        if (!date) return null;
        const [day, month, year] = date.split('/');
        //const [day, month, year] = date.split('-');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      },
      openmodal(editar) {
        //window.console.log(editar);
        this.xdocumento = null;
        this.xarchivo.Documento = null;
        this.date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
        this.date2 = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
        this.date3 = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
        this.dateFormatte = this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        );
        this.dateFormatted2 = this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        );
        this.dateFormatted3 = this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        );

        for (let name in this.xprograma) {
          this.xprograma[name] = null;
        }
        if (editar) {
          //this.date = editar.fecha_inscripcion;
          this.date2 = editar.fecha_inicio;
          this.date3 = editar.fecha_culminacion;
          this.xprograma.id = editar.id;
          this.xprograma.codigo = editar.codigo;
          this.xprograma.programa = editar.programa;
          this.xprograma.gestion = '' + editar.gestion;
          this.xprograma.version = editar.version;
          this.xprograma.area = editar.area;
          //this.xprograma.resolucion_aprobado_unsxx = editar.resolucion_aprobado_unsxx;
          /* this.xprograma.fecha_inscripcion = this.formatDate(editar.fecha_inscripcion);
          this.xprograma.fecha_inicio = editar.fecha_inicio;
          this.xprograma.fecha_culminacion = editar.fecha_culminacion; */
          this.xprograma.categoria_id = editar.categoria_id;
          this.xprograma.departamento_id = editar.departamento_id;
          this.xprograma.sede_id = editar.sede_id;
          this.xprograma.mes = editar.mes;
          //this.xprograma.monto_colegiatura = editar.monto_colegiatura;
          //this.xprograma.monto_matricula = editar.monto_matricula;
          //this.xprograma.monto_certificacion = editar.monto_certificacion;
        }
        this.edit = editar;
        this.dialog = true;
        this.msg = '';
        this.generatecode();
      },
      upper(v, ev) {
        if (!ev) return;
        this.xprograma[v] = ev.toUpperCase();
      },
      generatecode() {
        let str = this.xprograma.programa;
        if (!str) str = '';
        str = str.replace(/ +/g, ' ');
        let partes = str.split(' ');
        let code = 'PRY-';
        partes.forEach((x) => {
          if (x.length > 3 && code.length < 18) code += x[0];
        });
        if (this.xprograma.area) {
          let a = this.xprograma.area.substring(0, 2);
          code += `-${a}`;
        }
        if (this.xprograma.version) {
          let c = this.xprograma.version.padStart(3, '0');
          code += `-${c}`;
        }
        this.xprograma.codigo = code;
      },
      enviar() {
        /* window.console.log(this.dateFormatted, this.date);
        window.console.log(this.dateFormatted2, this.date2);
        window.console.log(this.dateFormatted3, this.date3); */

        //resolucion puede ser nulo
        //this.xprograma.fecha_inscripcion = this.date;
        this.xprograma.fecha_inicio = this.date2;
        this.xprograma.fecha_culminacion = this.date3;
        //window.console.log(JSON.stringify(this.xprograma, null, 4));

        this.msg = 'complete todos los datos del formulario.';
        if (!this.xprograma.codigo) return;
        if (!this.xprograma.programa) return;
        if (!this.xprograma.gestion) return;
        if (!this.xprograma.version) return;
        if (!this.xprograma.area) return;
        //if (!this.xprograma.resolucion_aprobado_unsxx) return;
        //if (!this.xprograma.fecha_inscripcion) return;
        if (!this.xprograma.fecha_inicio) return;
        if (!this.xprograma.fecha_culminacion) return;
        if (!this.xprograma.categoria_id) return;
        if (!this.xprograma.departamento_id) return;
        if (!this.xprograma.sede_id) return;
        if (!this.xprograma.mes) return;
        if (!this.xprograma.id && !this.xdocumento) {
          this.msg = 'Seleccione un documento (WORD) del proyecto.';
          return;
        }
        this.xprograma.gestion = '' + this.xprograma.gestion;
        //if (!this.xprograma.monto_colegiatura) return;
        //if (!this.xprograma.monto_matricula) return;
        //if (!this.xprograma.monto_certificacion) return;
        //window.console.log(JSON.stringify(this.xprograma, null, 4));
        this.msg = '';

        this.loading = true;
        const vue = this;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/programa-unsxx`;
        //const url = `http://localhost:8090/api/v1/programa-unsxx`;
        let data = this.xprograma;
        let axos = this.xprograma.id ? xaxios.put(url, data) : xaxios.post(url, data);
        axos
          .then((res) => {
            window.console.log(res);
            if (res.data.id) {
              vue.msg = `Registro exitoso: ${res.data.id}`;
              vue.$emit('xnewres', `Registro exitoso: ${res.data.id}`);
              //if (!this.xprograma.id) vue.uploaddocumento(res.data.id);
              if (this.xarchivo.Documento) vue.uploaddocumento(res.data.id);
              else {
                vue.loading = false;
                vue.dialog = false;
              }
            } else {
              vue.msg = 'No se pudo registrar: ' + res.data;
              vue.loading = false;
            }
            //vue.dialog = false;
          })
          .catch((error) => {
            vue.msg = error;
            vue.loading = false;
            let err = error.response.data.error;
            if (err.includes('Error 1062: Duplicate entry')) {
              vue.msg =
                'Segun el codigo generado este proyecto al parecer ya se encuentra registrado, si desea crear una nueva version, el responsable nacional puede crear nuevas versiones.';
            }
          });
      },
      uploaddocumento(idprograma) {
        this.msg = 'Proyecto guardado, subiendo el documento...';
        this.xarchivo.Idprograma = idprograma;
        const vue = this;
        //window.console.log('>>>>>>>>>>> ', this.xarchivo);

        const url = `${process.env.VUE_APP_API_REST}/api/v1/programasdocs/asignar`;
        //const url = `http://localhost:8090/api/v1/programasdocs/asignar`;
        var config = {
          method: 'post',
          url: url,
          headers: { 'Content-Type': 'application/json' },
          data: this.xarchivo,
        };

        xaxios.request(config)
          .then(function(response) {
            //window.console.log(JSON.stringify(response.data));
            vue.loading = false;
            vue.dialog = false;
            window.console.log('archivo subido id: ', response.data);
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
    },
    mounted() {
      this.$refs.programautils.getCategorias(this);
      this.$refs.programautils.getDepartamentos(this);
      this.$refs.programautils.getSedes(this);
    },
  };
</script>
